import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { allSteps, firstStep } from './stepper.machine';
import { StepperState } from './stepper.types';
import { compareSteps } from './stepper.utils';

import type { StepName } from '~/core/enums';
import { takeAllBefore } from '~/core/utils/misc.utils';

const initialState: StepperState = {
  current: firstStep,
  enabledSteps: [firstStep],
  steps: allSteps,
  allowAutoNavigation: true,
};

const stepperSlice = createSlice({
  name: 'stepper',
  initialState,

  reducers: {
    enableStep: (
      state: StepperState,
      { payload: step }: PayloadAction<StepName>
    ): void => {
      state.enabledSteps = [...new Set([...state.enabledSteps, step])].sort(
        compareSteps
      );
    },
    enableAllSteps: (state: StepperState) => {
      state.enabledSteps = allSteps;
    },
    goToStep: (
      state: StepperState,
      { payload: stepName }: PayloadAction<StepName>
    ): void => {
      state.current = stepName;
    },
    resetStepper: (
      state: StepperState,
      { payload: step }: PayloadAction<StepName>
    ) => {
      state.enabledSteps = takeAllBefore(state.enabledSteps, step);

      if (!state.enabledSteps.includes(state.current)) {
        const [lastEnabledStep] = state.enabledSteps.slice(-1);

        state.current = lastEnabledStep;
      }
    },
    updateSteps: (
      state: StepperState,
      { payload: steps }: PayloadAction<StepName[]>
    ): void => {
      state.steps = steps;
    },
    setAllowAutoNavigation: (
      state: StepperState,
      { payload: shouldAllowAutoNavigation }: PayloadAction<boolean>
    ): void => {
      state.allowAutoNavigation = shouldAllowAutoNavigation;
    },
  },
});

export const {
  enableStep,
  enableAllSteps,
  goToStep,
  resetStepper,
  updateSteps,
  setAllowAutoNavigation,
} = stepperSlice.actions;

export default stepperSlice.reducer;
